/**
 * The connection form (Option C, C2): four sections in one order for every engine — General, the target (Server,
 * File, Cluster or Storage), Security (where the engine has any), More options — built from `FormSection` and the
 * label-left `FormRow` (`connection-dialog/pane/`). The rows live in `connection-dialog/fields/`; each renders only while
 * its field rule applies (C0), and collapsed sections stay mounted.
 */
import { GeneralSection } from '../connection-dialog/fields/GeneralSection';
import { TargetSection, type TargetSectionProps } from '../connection-dialog/fields/TargetSection';
import { SecuritySection } from '../connection-dialog/fields/SecuritySection';
import { OptionsSection } from '../connection-dialog/fields/OptionsSection';

type ConnectionFormFieldsProps = Omit<TargetSectionProps, 'loadedDatabases' | 'loadingDatabases'> & {
  /** Databases listed by Load (shown while their target is on screen). */
  loadedDatabases?: string[];
  loadingDatabases?: boolean;
};

export function ConnectionFormFields({ loadedDatabases = [], loadingDatabases = false, ...props }: ConnectionFormFieldsProps) {
  const { form, engine } = props;
  return (
    <>
      <GeneralSection form={form} engine={engine} />
      <TargetSection {...props} loadedDatabases={loadedDatabases} loadingDatabases={loadingDatabases} />
      <SecuritySection form={form} engine={engine} />
      <OptionsSection form={form} engine={engine} />
    </>
  );
}
